import React from "react";

export default function FallbackUI(): JSX.Element {
    return (
        <div style={{ width: 600, margin: "0 auto", color: "#FF0000", textAlign: "center" }}>
            <p>
                <h2>The app has encountered something unexpected!</h2>
                <h3>Some diagnostic information has been sent to the support team automatically.</h3>
                <h3>For further help, please contact the developers.</h3>
            </p>
        </div>
    );
}
